import { Alert, Snackbar } from "@mui/material";
import { useNotifications } from "@/shared/stores/notificationStore";

export function Notifications() {
	const notifications = useNotifications((state) => state.notifications);
	const dismissNotification = useNotifications((state) => state.dismissNotification);

	return (
		<>
			{notifications.map((notification) => (
				<Snackbar
					key={notification.id}
					open={true}
					autoHideDuration={6000}
					onClose={() => dismissNotification(notification.id)}
					anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
					sx={{ mb: notifications.indexOf(notification) * 7 }}
				>
					<Alert
						onClose={() => dismissNotification(notification.id)}
						severity={notification.type}
						variant="filled"
					>
						<strong>{notification.title}</strong>
						{notification.message && <div>{notification.message}</div>}
					</Alert>
				</Snackbar>
			))}
		</>
	);
}
